





























































// @ is an alias to /src

import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { LessonStates } from '../../../src_server/entity/master/LessonStates';

import FullCalendar, { FullCalendarComponent } from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin, { TimeGridView } from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import { EventApi } from '@fullcalendar/core';
import { dayjs, DT_FORMAT_INPUT } from '../../../src_server/common/momentExtends';
import '@fullcalendar/core/main.css'
import '@fullcalendar/daygrid/main.css'
import '@fullcalendar/timegrid/main.css'


// eslint-disable-next-line @typescript-eslint/no-var-requires
const jaLocale = require('@fullcalendar/core/locales/ja'); // 日本語化用

export class EventColor {
  static SCHEDULE = 'deepskyblue';
  static SCHEDULE_PLAN = 'lightgreen';
  static COMMITED = 'mediumaquamarine';
  static TRANSFER = 'crimson';
  static DONE = 'whitesmoke';
  static RESERVATION_REQ = 'springgreen';
  static ANOTER_RESERVATION = 'gray';
  static DELETED = 'gray';
  static ALL_DAY = 'orange';
}

export class LessonStatesColor {
  static getColor(state: string) {
    switch (state) {
      case LessonStates.RESERVATION:
        return EventColor.RESERVATION_REQ;
      case LessonStates.COMMIT:
        return EventColor.COMMITED;
      case LessonStates.TRANSFAR:
        return EventColor.TRANSFER;
      case LessonStates.ALREADY:
        return EventColor.DONE;
      case LessonStates.DELETED:
        return EventColor.DELETED;
      default:
        return EventColor.DELETED;
    }
  }
}

export type CalendarEvent = {
  title: string;
  start: string | Date;
  end: string | Date;
  backgroundColor?: string;
  rendering?: string;
  classNames?: string[];
  type?: 'request' | 'commited' | 'teacher_enable' | 'reservation' | 'transfer' | 'already';
  weekly?: boolean;
  weeklyNo?: number;
  id: number;
  allDay?: boolean;
};
export type DatesRenderEvent = {
  view: TimeGridView;
  el: any;
};
export type DateClickEvent = {
  date: Date;
  dateStr: string;
  allDay: boolean;
  resource?: any;
  event?: EventApi;
  dayEl: HTMLElement;
  jsEvent: MouseEvent;
  view: any;
};

@Component({
  components: {
    FullCalendar,
  },
})
export default class CommonCalendar extends Vue {
  // カレンダーで使用するプラグイン
  public calendarPlugins = [timeGridPlugin, dayGridPlugin, interactionPlugin, listPlugin];

  /**
   * 日本語化
   */
  public locale = jaLocale;

  /**
   * 編集可能にするか
   */
  @Prop({ default: true })
  private editable!: boolean;

  private columnHeaderFormat = {
    day: '2-digit',
    weekday: 'short',
  };

  /**
   * 土日を表示するか
   */
  public calendarWeekends = true;

  /**
   * ボタンの文字
   */
  public buttonText = {
    today: '今日',
    month: '月',
    week: '週',
    day: '日',
    list: '表',
  };

  @Prop({ default: 'timeGridWeek' })
  private defaultView!: string;

  @Prop()
  header!: { left: string; center: string; right: string };

  /**
   * カレンダーヘッダーのデザイン
   */
  get calendarHeader() {
    if (this.header) return this.header;
    return {
      left: 'prev,next',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay',
    };
  }

  @Prop()
  calendarEvents!: CalendarEvent[];

  get calendarEventsModel() {
    return this.calendarEvents.map((c) => {
      c.start = dayjs(c.start).format(DT_FORMAT_INPUT);
      c.end = dayjs(c.end).format(DT_FORMAT_INPUT);
      return c;
    });
  }

  @Emit('handleDateClick')
  public handleDateClick(arg: DateClickEvent) {
    // console.log('handleDateClick', arg);
  }

  @Emit('eventResize')
  public eventResize(info: any) {
    // alert(info.event.title + ' end is now ' + info.event.end.toISOString());
    // if (!confirm('is this okay?')) {
    //   info.revert();
    // }
  }
  @Emit('eventResizeStart')
  private eventResizeStart(info: any) {
    //
  }

  @Emit('eventClick')
  public eventClick(e: DateClickEvent) {
    console.log('event ', e);
    e.jsEvent.preventDefault(); // don't let the browser navigate
  }

  @Emit('handleSelect')
  public handleSelect(e: DateClickEvent) {
    // console.log('handleselect', e);
  }

  @Emit('eventDragStart')
  public eventDragStart(e: Event) {
    // console.log('eventDragStart', e);
  }

  @Emit('eventDragStop')
  public eventDragStop(e: Event) {
    // console.log('eventDragStop', e);
  }

  @Emit('eventDrop')
  public eventDrop(e: any) {
    // console.log('eventDrop', e);
    return e.event;
  }

  @Emit('datesRender')
  public datesRender(event: DatesRenderEvent) {
    // console.log('datesRender');
    document.querySelectorAll(`[style="background-color:darkgreen"]`).forEach((i: any) => {
      i.style.color = 'white';
    });
  }

  public getApi() {
    // getApi
    return (this.$refs.fullCalendar as FullCalendarComponent).getApi();
    // console.log('calendarApi', calendarApi.view);
  }
}
